import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";
import { useEffect, useState } from "react";



function WalletOwnerManagement() {
	const { t } = useTranslation();
	const history = useHistory();
	const Theme = useSelector((state) => state.theme.theme);

	const { pathname } = useLocation();

	const {
		data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed }
	} = useSelector(({ walletSetting }) => walletSetting);
	const getMappedListForAdminRes = useSelector(
		({ getMappedListsForadmins }) => getMappedListsForadmins
	)
	const [allowedSubModules, setAllowedSubModules] = useState([]);
	const partnerloginUser = useSelector(({ login }) => login);
	var authTokens = partnerloginUser.data.AuthToken;
	sessionStorage.setItem("walletOwnerId", partnerloginUser.data.partnerId);


	const options = [
		{
			id: 1,
			// label: "My Banks",
			label: "Create Owner",
			// route: "/index/block-country",
			route: "/index/create-wallet-owner",
			src: `${process.env.PUBLIC_URL}/${Theme}/CREATE OWNER.png`,
			flag: "CREATE OWNER",
		},
		{
			id: 2,
			// label: "My Banks",
			label: "Owner Settings",
			// route: "/index/block-country",
			route: "/index/wallet-owner-settings",
			src: `${process.env.PUBLIC_URL}/${Theme}/OWNER SETTINGS.png`,
			flag: "OWNER SETTINGS",

		},
		{
			id: 3,
			// label: "My Banks",
			label: "Role Management",
			// route: "/index/block-country",
			route: "/index/role-management",
			src: `${process.env.PUBLIC_URL}/${Theme}/ROLE MANAGEMENT.png`,
			flag: "ROLE MNT",

		},
		{
			id: 4,
			// label: "My Banks",
			label: "Entity Type Management",
			// route: "/index/block-country",
			route: "/index/entity-type-management",
			src: `${process.env.PUBLIC_URL}/${Theme}/MyAccounts.png`,
			flag: "ENTITY TYPE MNT",
		},
		{
			id: 5,
			label: "Business Nature Management",
			// route: "/index/risk-rules",
			route: "/index/business-nature-management",
			src: `${process.env.PUBLIC_URL}/${Theme}/BUSINESS NATURE MANAGEMENT.png`,
			flag: "BUSINESS NATURE MNT",
		},
		{
			id: 6,
			label: "Business Nature Sub-Categoty",
			// route: "/index/risk-rules",
			route: "/index/AdminBusinessNatureSubCategory",
			src: `${process.env.PUBLIC_URL}/${Theme}/BUSINESS NATURE MANAGEMENT.png`,
			flag: "BUSINESS NATURE SUB-CATEGORY"
		},
		{
			id: 6,
			label: "IBAN Provider Management",
			// route: "/index/risk-rules",
			route: "/index/AdminIBNProviderManagement",
			src: `${process.env.PUBLIC_URL}/${Theme}/MyBank.png`,
			flag: "BUSINESS NATURE SUB-CATEGORY"
		}

		// {
		//   id: 4,
		//   label: "My Wallets",
		//   route: "/index/my-wallets",
		//   src: `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`,
		// },
		//   {
		//     id: 5,
		//     label: "Create Wallet",
		//     route: "/index/create-wallet",
		//     src: `${process.env.PUBLIC_URL}/${val.theme}/ApiKey.png`,
		//   },
	];
	let filteredOptions = [];
	if (partnerloginUser.data.partnerId === "2" || partnerloginUser.data.partnerId === "105"
		|| partnerloginUser.data.partnerId === "200"
	) {
		filteredOptions = options;
	} else {
		const allowedFlags = getMappedListForAdminRes?.data?.moduleAllocationVO?.masterSubModuleMappingList || [];
		filteredOptions = options.filter(({ flag }) => allowedFlags.includes(flag));
	}

	const filteredOptns = options.filter(({ label }) => {
		// if (
		//   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
		// ) {
		//   return label !== "My Cards";
		// }
		// else if (
		//   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
		// )
		// {
		//   return label !== "My Banks";
		// }
		if (
			label === "My Wallets" &&
			!constants.visibleFlags.includes(isMyWalletAllowed)
		) {
			// return label !== "My Wallets";
		} else return true;
	});
	// .sort((a, b) => {
	//   return a.label > b.label ? 1 : -1;
	// });

	if (!filteredOptns.length) {
		return (
			<Layout>
				<Card className="mk-root">
					<Row className="mk-row m-auto">No My Accounts Available</Row>
				</Card>
			</Layout>
		);
	}

	const handleRoute = (route) => {
		history.push({ pathname: route, state: { from: pathname } });
	};

	return (
		<Layout>
			<Card className="mk-root">
				<Row className="mk-row">
					{filteredOptions.map(({ id, src, label, route }) => (
						<Col key={id} md={4} sm={4} xs={6}>
							<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
								<div className="mk-imageContainer">
									<img className="mk-image" src={src} alt={label} />
								</div>
								<Label for={label} className="fs-14">
									{t(label)}
								</Label>
							</div>
						</Col>
					))}


					{/* {options.map(({ id, src, label, route, flag }) => {
						if (
							getMappedListForAdminRes.success &&
							getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
						) {
							return (<Col key={id} md={4} sm={4} xs={6}>
								<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
									<div className="mk-imageContainer">
										<img className="mk-image" src={src} alt={label} />
									</div>
									<Label for={label} className="fs-14">
										{t(label)}
									</Label>
								</div>
							</Col>)
						}
					})} */}
				</Row>
			</Card>
		</Layout>
	);
}

export default WalletOwnerManagement;
